/**
 *
 * Copyright(c) 2024 Magrabi.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Magrabi ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Magrabi.
 *
 *
 * @author Sivaprasad
 *
 */

import { FC } from "react";
import { IconProps } from "@/common/lib/types";

const Icon: FC<IconProps> = (props) => {
  return (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="9" cy="9" r="8" stroke="black" strokeWidth="2" />
      <path fillRule="evenodd" clipRule="evenodd" d="M10 4H8V9V11H13V9H10V4Z" fill="black" />
    </svg>
  );
};

export default Icon;
